
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Venue } from '@/interfaces/models/Venue';
import LanguagePicker from '@/components/layout/LanguagePicker.vue';
import ExternalOrderProviderStatus from '@/components/venue/ExternalOrderProviderStatus.vue';
import SyncExternalFoodcardsButton from '@/components/article/SyncExternalFoodcardsButton.vue';
import { venueFilter } from '@/util/helper';
import { Permission } from '@/enums/Permission';
import cookie from 'js-cookie';

@Component({
  components: { LanguagePicker, ExternalOrderProviderStatus, SyncExternalFoodcardsButton },
})
export default class Toolbar extends Vue {
  @Prop({ type: Array, required: true }) public items!: Venue[];
  @Prop({ type: String, default: '' }) public active!: string;
  @Prop({ type: Boolean, default: true }) public drawer!: boolean;

  public drawerVisible: boolean = true;

  protected search: string = '';

  protected fuseIndex: any;

  get venue() {
    if (this.active) {
      return this.items.find((v: Venue) => v._id === this.active);
    }

    return null;
  }

  get name() {
    return cookie.get('name');
  }

  get nameMobile() {
    return this.name?.charAt(0).toUpperCase() || '';
  }

  get showExternalOrderProviderStatus() {
    const provider = this.venue?.externalOrderProviders;

    if (!provider) {
      return;
    }

    const { uberEats, wolt } = provider;
    return uberEats?.enabled || wolt?.enabled;
  }

  @Watch('drawer')
  public onDrawerChange(val: boolean, oldVal: boolean) {
    if (val !== oldVal) {
      this.drawerVisible = val;
    }
  }

  @Emit('drawer')
  public toggleDrawer() {
    this.drawerVisible = !this.drawerVisible;
    return this.drawerVisible;
  }

  public filter(item: Venue, queryText: string): boolean {
    return venueFilter(item, queryText.trim());
  }

  public editVenue() {
    if (!this.venue) {
      return;
    }
    if (this.$can(Permission.VENUE_UPDATE)) {
      this.$router.push({ name: 'venue.edit', params: { id: this.venue._id } });
    } else {
      this.$router.push({ name: 'venue.editSimple', params: { id: this.venue._id } });
    }
  }

  public copy(value: string) {
    if (value) {
      navigator.clipboard.writeText(value);
    }
  }

  @Watch('search')
  @Emit('selected')
  public onSearch() {
    return this.items.find((item: Venue) => item._id === this.search)!;
  }

  @Watch('active')
  public onActiveChange() {
    this.search = this.active;
  }
}
